import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";

const axisNameColor = '#334155';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'

const ComboChart = ({
    chartData = [],
    chartLabel,
    xField,
    barField,
    lineField,
    xAxisTitle = "",
    leftAxisTitle = "",
    rightAxisTitle = "",
    barLabel = "Bar",
    lineLabel = "Line",
    tooltipFields = [],
    fieldsLabel = "",
    purpose = "",
}) => {


    const graphData =
        chartData && chartData.length > 0
            ? chartData
            : []

    const option = {
        tooltip: {

            trigger: "axis",

            axisPointer: {
                type: "shadow",
            },

            formatter: (params) => {
                const item = graphData[params[0].dataIndex];
                let html = "";
                if (purpose) {
                    html += `<b>Purpose</b><br/>${purpose}<br/><br/>`;
                }
                // html += `<b>${item[xField]}</b><br/>`;
                html += `<b>${barLabel}</b> : ${item[barField]}<br/>`;
                html += `<b>${lineLabel}</b> : ${item[lineField]}<br/>`;
                tooltipFields.forEach((field) => {
                    let value = item[field.key];
                    if (
                        value &&
                        (field.key.toLowerCase().includes("date"))
                    ) {

                        const date = new Date(value);

                        value = `${String(date.getDate()).padStart(2, "0")}-${String(
                            date.getMonth() + 1
                        ).padStart(2, "0")}-${date.getFullYear()}`;
                    }

                    html += `<b>${field.label}</b> : ${value ?? "-"}<br/>`;

                });

                return html;
            },
        },

        legend: {
            top: 5,
            left: "center",
            data: [
                barLabel,
                lineLabel,
            ],
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
        },

        grid: {
            left: "5%",
            right: "5%",
            bottom: "30%",
            top: "10%",
            containLabel: true,
        },

        xAxis: {
            type: "category",
            name: xAxisTitle,
            nameLocation: "middle",
            nameGap: 100,
            data: graphData.map(item => item[xField]),
            // data: graphData?.map(item =>
            //     item?.resourceName?.split(" ")[0] || "Dummy Name"
            // ),
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },

            axisTick: {
                show: false,
            },

            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },

            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 30,
            },

            splitLine: {
                show: false,
            },
        },

        yAxis: [

            {
                type: "value",
                name: leftAxisTitle,
                position: "left",
                nameLocation: "middle",
                nameGap: 35,
                nameTextStyle: {
                    fontSize: 14,
                    fontWeight: "bold",
                    color: axisNameColor,
                },
                splitLine: {
                    lineStyle: {
                        color: "#ECECEC",
                    },
                },
                axisLabel: {
                    show: true,
                    color: labelColor,
                    fontSize: 11,
                    rotate: 0,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: axisLineColor,
                        width: axisLineWidth,
                    },
                },
            },

            {
                type: "value",
                name: rightAxisTitle,
                position: "right",
                nameLocation: "middle",
                nameGap: 35,
                splitLine: {
                    show: false,
                },
                nameTextStyle: {
                    fontSize: 14,
                    fontWeight: "bold",
                    color: axisNameColor,
                },
                axisLabel: {
                    show: true,
                    color: labelColor,
                    fontSize: 11,
                    rotate: 0,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: axisLineColor,
                        width: axisLineWidth,
                    },
                },
            },
        ],

        series: [

            {
                name: barLabel,
                type: "bar",
                barWidth: 35,
                data: graphData.map(item => item[barField]),
                itemStyle: {
                    color: "#CBD5E1",
                    borderRadius: [6, 6, 0, 0],
                },
            },

            {
                name: lineLabel,
                type: "line",
                yAxisIndex: 1,
                smooth: true,
                symbol: "circle",
                symbolSize: 8,
                data: graphData.map(item => item[lineField]),
                lineStyle: {
                    color: "#F59E0B",
                    width: 3,
                },
                itemStyle: {
                    color: "#F59E0B",
                },
            },
        ],
    };

    return (
        <ChartCard
            title={chartLabel}
            height={420}
        >
            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </ChartCard>
    );
};

export default ComboChart;